function maskEmail(email) {
  let atIndex = email.indexOf("@");
  if (atIndex <= 1) {
    return email; // email address too short to mask
  }
  let masked =
    email.charAt(0) + Array(atIndex - 1).join("*") + email.substring(atIndex);
  return masked;
}

export default maskEmail;